function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M112.17 93.6742L80.7474 111.816L47.8303 92.9926V84.2859L80.7474 102.959L96.7626 93.7125L85.872 87.4251L81.8608 89.7409L74.6184 85.5849L78.6513 83.2565L73.2814 80.1563L70.0283 82.0345L62.7859 77.8785L66.0608 75.9877L49.325 66.3258L80.7473 48.1841L110.036 65.0936L102.482 69.5895L80.7474 57.0412L64.8582 66.2148L73.8993 71.4622L78.2659 68.9411L85.5083 73.0971L81.1007 75.6419L86.4564 78.7503L90.0984 76.6476L97.3408 80.8036L93.6578 82.9299L112.17 93.6742Z",
  fill: "white"
});

function SvgCoinIconIost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIconIost);
export default __webpack_public_path__ + "static/media/CoinIconIOST.5560f326.svg";
export { ForwardRef as ReactComponent };